import { PageBudgetExceeded } from "@components/modules/projects/budget-exceeded/PageBudgetExceeded";
import { DemoModule, Modules } from "@components/widgets/DemoModule";
import { MainLayout } from "@components/widgets/Layout";
import { t } from "@lingui/macro";
import NavigationReports, {
  type NavigationReportsProps,
} from "@src/components/widgets/AppSubNav/NavigationReports/NavigationReports";
import { createFileRoute } from "@tanstack/react-router";

const report: NavigationReportsProps["currentReport"] = {
  href: "/reports/budget-exceeded",
  title: () => t`Budget exceeded`,
};

const Page = () => (
  <MainLayout
    title={report.title()}
    navigation={<NavigationReports currentReport={report} />}
  >
    <DemoModule module={Modules.ProjectsBudgetExceeded}>
      <PageBudgetExceeded />
    </DemoModule>
  </MainLayout>
);

export const Route = createFileRoute("/reports/budget-exceeded")({
  component: Page,
});
